import { Component } from '@angular/core';

@Component({
    selector: 'informacion-svg',
    templateUrl: './informacion.component.svg',
    standalone: false
})
export class InformacionSvgComponent { }